import React from 'react';
import {Box, Typography, Container, Link, Divider, useTheme} from '@mui/material';
import {School as SchoolIcon} from '@mui/icons-material';

const Footer = () => {
    const theme = useTheme();

    return (
        <Box
            component="footer"
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: (theme) => theme.zIndex.drawer + 1,
                paddingY: 2,
                backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(34, 38, 47, 0.3)' // Your dark paper color with transparency
                    : 'rgba(245, 247, 250, 0.1)', // Your light default color with transparency
                backdropFilter: 'blur(12px)',
                borderTop: `1px solid ${theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.1)'
                    : 'rgba(0, 0, 0, 0.1)'}`,
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: {xs: 'column', md: 'row'},
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Box sx={{display: 'flex', alignItems: 'center', mb: {xs: 1, md: 0}}}>
                        <SchoolIcon sx={{mr: 1, color: theme.palette.primary.main}}/>
                        <Typography variant="h6" color="primary" sx={{fontWeight: 700}}>
                            DuoQuanto
                        </Typography>
                    </Box>

                    <Box sx={{display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', justifyContent: 'center'}}>
                        <Typography variant="body2" color="text.secondary" align="center">
                            {'© '}
                            {new Date().getFullYear()}
                            {' '}
                            <Link
                                color="secondary"
                                href="#"
                                underline="hover"
                                sx={{
                                    fontWeight: 600,
                                    transition: 'color 0.15s',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    }
                                }}
                            >
                                DuoQuanto TechLab
                            </Link>
                            {' – Team 2'}
                        </Typography>
                        <Divider orientation="vertical" flexItem sx={{display: {xs: 'none', md: 'block'}}}/>
                        <Box sx={{display: 'flex', gap: 2}}>
                            <Link
                                href="/impressum"
                                color="text.secondary"
                                underline="hover"
                                sx={{
                                    fontSize: '0.875rem',
                                    transition: 'color 0.15s',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    }
                                }}
                            >
                                Impressum
                            </Link>
                            <Link
                                href="/datenschutz"
                                color="text.secondary"
                                underline="hover"
                                sx={{
                                    fontSize: '0.875rem',
                                    transition: 'color 0.15s',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    }
                                }}
                            >
                                Datenschutz
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;